export const getCurrentPageChannel = () => {
    let channel = null;
    try {
        try {
            const articleSectionMeta = document.querySelector('meta[property="article:section"]');
            if (articleSectionMeta && articleSectionMeta.getAttribute('content')) {
                channel = articleSectionMeta.getAttribute('content');
            }
        }
        catch (error) {
            // Ignore, fail onto PageCriteria
        }
        if (!channel && window && 'PageCriteria' in window) {
            channel = window.PageCriteria.subchannel;
        }
        if (channel) {
            return channel.toLowerCase();
        }
    }
    catch (error) {
        // Not familiar with this codebase so coding a bit defensively here
    }
    return null;
};
